<template>
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Journal Nachricht erfassen</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          @click="cancel"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form>
          <div class="form-group">
            <label for="exampleFormControlInput1">Email</label>
            <input
              type="email"
              class="form-control"
              id="exampleFormControlInput1"
              placeholder="name@example.com"
              v-model="journalEntry.email"
            />
          </div>
          <div class="form-group">
            <label for="firstName">Vorname</label>
            <input
              type="text"
              class="form-control"
              id="firstName"
              placeholder="First Name"
              v-model="journalEntry.firstName"
            />
          </div>
          <div class="form-group">
            <label for="lastName">Name</label>
            <input
              type="text"
              class="form-control"
              id="lastName"
              placeholder="Name"
              v-model="journalEntry.lastName"
            />
          </div>
          <div class="form-group">
            <label for="phoneNr">Telefonnummer</label>
            <input
              type="text"
              class="form-control"
              id="phoneNr"
              placeholder="+41 61 555 5555"
              v-model="journalEntry.phoneNr"
            />
          </div>
          <div class="form-group" v-if="loggedIn">
            <label for="private">Privat</label>
            <input
              type="checkbox"
              id="private"
              v-model="journalEntry.private"
            />
          </div>
          <div class="form-group">
            <label for="text">Nachricht</label>
            <textarea
              class="form-control"
              id="text"
              rows="4"
              v-model="journalEntry.text"
            ></textarea>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <div class="row mx-auto">
          <div class="col-xs-6 mx-1">
            <button
              @click="save()"
              type="button"
              class="btn btn-outline-dark btn-block"
            >
              <i class="far fa-save"></i>&nbsp;Speichern
            </button>
          </div>
          <div class="col-xs-6 mx-1">
            <button
              @click="cancel()"
              type="button"
              class="btn btn-outline-dark btn-block"
              data-dismiss="modal"
            >
              <i class="far fa-times-circle"></i>&nbsp;Abbrechen
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { emptyJournalEntry } from "@/common/constants";

export default {
  name: "journalEntryComponent",
  data: function() {
    return {
      journalEntry: emptyJournalEntry
    };
  },
  mounted() {
    if (this.journalEntryProperty) {
      this.journalEntry = this.journalEntryProperty;
    } else {
      this.prepareJournalEntry();
    }
  },
  methods: {
    newMessage(text) {
      this.prepareJournalEntry();
      this.journalEntry.text = text;
    },
    prepareJournalEntry() {
      this.journalEntry = JSON.parse(JSON.stringify(emptyJournalEntry));
    },
    save() {
      this.$emit("savejournalentry", this.journalEntry);
    },
    cancel() {
      this.$emit("cancel");
    }
  },
  props: {
    journalEntryProperty: Object,
    loggedIn: Boolean,
    tp: Object
  }
};
</script>
